import requestManager from "@comp/platformApi/requestManager";
import appHelper from "@util/appHelper";

export default {

    list : {
        url : 'portal/courseVod/listForAudience'
    },

    vipCourselist : {
        url : 'portal/user/vip/getVipCourse'
    },

    applyFree : {
        url : 'portal/courseVod/apply_free_course_vod',
        method : 'post'
    },

    prepay() {
        return {
            url : 'portal/order/pay/prepay_video_on_demand',
            method : 'post'
        }
    },

    getPayStatus() {
        return {
            url : 'portal/order/manage/get',
            method : 'post'
        }
    },

    getCategoryList(params = {}, callback) {
        requestManager.request({
            url : 'portal/course/classify/list_category_all',
            data : params
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
            }

            callback(result.data);
        });

    },

    /**
     * @param   {Object}    params
     * @param   {String}    params.id
     * @param   {String}    params.proportion
     * @param   {Function}  callback
     */
    subProportion(params = {}, callback) {
        requestManager.request({
            url : 'portal/vod/v2/subProportion',
            method : 'PUT',
            data : params
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
            }

            callback(result.data);
        });

    }
};
